import React, { useState, useMemo } from "react"
import useMediaQuery from "@mui/material/useMediaQuery"
import TabsMui from "../layout/TabsMui"

import OrderDetailsTab from "./tabs/OrderDetailsTab"
import OrderInvoiceDetailsTab from "./tabs/OrderInvoiceDetailsTab"
import SalesOrderDetailsTab from "./tabs/SalesOrderDetailsTab"

import {
  ORDER_STATUS_UI_MAP,
  ORDER_TAB_VALUES,
  buildOrderTabs
} from "./constants/orderConstants"
import { layoutMobileMediaQuery } from "../layout/layoutConstants"

const DEFAULT_TAB = ORDER_TAB_VALUES.ORDER

const ShowOrderView = ({ order, invoiceApp = [], salesOrder }) => {
  const [activeTab, setActiveTab] = useState(DEFAULT_TAB)
  const isMobileLayout = useMediaQuery(layoutMobileMediaQuery)

  if (!order) return null

  const tabs = useMemo(() => {
    return buildOrderTabs(invoiceApp, !!salesOrder)
  }, [invoiceApp, salesOrder])

  const statusUI = ORDER_STATUS_UI_MAP?.[order?.status] || null

  return (
    <>
      <div className="main-show-header">
        <h2>Pedido: {order?.order_db_ref ?? "N/A"}</h2>
      </div>

      <div className="index-table">
        <div className="show-area">
          <TabsMui
            tabs={tabs}
            activeTab={activeTab}
            onChange={setActiveTab}
            scrollable={tabs.length > 1}
            appearance="modern"
            status={!isMobileLayout && (
              <>
                <span>Estado:</span>
                <span className={`order-status ${statusUI?.className || ''}`}>
                  {statusUI?.label || order?.status || '-'}
                </span>
              </>
            )}
          />
          <div className="tab-content-area">

            {activeTab === ORDER_TAB_VALUES.ORDER && (
              <OrderDetailsTab
                orderDetails={order}
                statusUI={statusUI}
                showStatusInHeader={isMobileLayout}
              />
            )}

            {invoiceApp?.map((item, index) =>
              activeTab === `invoice-${index}` ? (
                <OrderInvoiceDetailsTab
                  key={index}
                  orderDetails={order}
                  invoiceAppDetails={item}
                  statusUI={statusUI}
                  fallbackStatus={order?.status}
                  showStatusInHeader={isMobileLayout}
                />
              ) : null
            )}

            {activeTab === ORDER_TAB_VALUES.SALES_ORDER && salesOrder && (
              <SalesOrderDetailsTab
                salesOrder={salesOrder}
                statusUI={statusUI}
                fallbackStatus={order?.status}
                showStatusInHeader={isMobileLayout}
              />
            )}

          </div>

        </div>
      </div>
    </>
  )
}

export default ShowOrderView
